// extracted by mini-css-extract-plugin
export default {"video_player":"BaseVideo_video_player_hKXIs"};